module.exports = __webpack_public_path__ + "img/item3.ab37ba54.png";